<template>
   <div>
      <ddoSelect2 :callbacks="callbacks" ref="mySelect" :options="options">
         <template v-slot:selection="data">
            <v-chip
               v-bind="data.attrs"
               :input-value="data.selected"
               close
               @click:close="remove(data.item)"
            >
               <span v-text="data.item.equ_name"></span>
            </v-chip>
         </template>

         <template v-slot:item="data">
            <v-list-item-content>
               <v-list-item-title v-html="data.item.equ_name"></v-list-item-title>
            </v-list-item-content>
         </template>
      </ddoSelect2>
    </div> 
</template>

<script>
import ddoSelect2 from '@/components/ddoSelect2.vue';

export default {
   name: 'ddoSelectEquipment',
   mixins: [ddoSelect2],

   components: {
      ddoSelect2
   },

   async mounted() {
      if ( !this.callbacks.refresh_rows ) {
         this.callbacks.refresh_rows = this.build_select_equ;
      }
   },

   methods: {
      async build_select_equ(key=null) {
         this.$emit('loading',true);
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'equipment');
         this.$emit('loading',false);
         return { errorinfos, api_response }
      },
   },

}
</script>